import icon96 from '../images/ms-icon-96x96.png';
import menuToBanner from '../images/menu-top-banner.png';
import cart from '../images/cart.png';

export default {
  qrIcon96: icon96,
  menuToBanner,
  cart,
};
